import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './Auth.css';

const VerifyEmail = () => {
  const { token } = useParams();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('Verificando tu email...');

  useEffect(() => {
    if (token) {
      verifyEmailToken(token);
    } else {
      setStatus('error');
      setMessage('Token de verificación no válido.');
    }
  }, [token]);

  const verifyEmailToken = async (verificationToken) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/verify-email/${verificationToken}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();

      if (data.success) {
        setStatus('success');
        setMessage(data.message || 'Email verificado exitosamente. Ya puedes iniciar sesión.');
      } else {
        setStatus('error');
        setMessage(data.message || 'Error al verificar el email. El enlace puede haber expirado.');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Error al conectar con el servidor. Inténtalo más tarde.');
      console.error('Error verifying email:', error);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>Verificación de Email</h1>
          </div>

          <div className="verification-content" style={{ textAlign: 'center', padding: '2rem 0' }}>
            {status === 'verifying' && (
              <div>
                <div className="loading-spinner" style={{
                  margin: '2rem auto',
                  width: '50px',
                  height: '50px',
                  border: '4px solid #f3f3f3',
                  borderTop: '4px solid #007bff',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite'
                }}>
                </div>
                <p>{message}</p>
              </div>
            )}

            {status === 'success' && (
              <div>
                <div style={{
                  fontSize: '4rem',
                  color: '#28a745',
                  marginBottom: '1rem'
                }}>
                  ✅
                </div>
                <div className="alert alert-success">
                  {message}
                </div>
                <p style={{ margin: '2rem 0', color: '#666' }}>
                  Tu cuenta ha sido verificada exitosamente. Ahora puedes acceder a todas las funcionalidades de la tienda.
                </p>
                <Link to="/login" className="btn btn-primary">
                  Iniciar Sesión
                </Link>
              </div>
            )}

            {status === 'error' && (
              <div>
                <div style={{
                  fontSize: '4rem',
                  color: '#dc3545',
                  marginBottom: '1rem'
                }}>
                  ❌
                </div>
                <div className="alert alert-error">
                  {message}
                </div>
                <p style={{ margin: '2rem 0', color: '#666' }}>
                  Si crees que esto es un error o necesitas un nuevo enlace de verificación, por favor contacta con soporte o intenta registrarte nuevamente.
                </p>
                <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
                  <Link to="/register" className="btn btn-secondary">
                    Registrarse nuevamente
                  </Link>
                  <Link to="/login" className="btn btn-primary">
                    Ir al Login
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default VerifyEmail;